export const NAME = 'ncrFormElements';
